<template>
	<v-card class="elevation-1" color="white">
		<v-card-title class="secondary--text">
			<v-spacer></v-spacer>

			<v-icon color="secondary" @click="closeBookingConfirmed()">mdi-close</v-icon>
		</v-card-title>
		<v-row no-gutters>
			<v-col>
				<div align="center" justify="center">
					<v-avatar color="white" size="100">
						<img class="white--text align-end" height="30" :src="require('@/assets/icons/✅.svg')" />
						<!--img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" --/ -->
					</v-avatar>
				</div>
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col>
				<p color="primary--text" class="title" align="center" justify="center">Booking Declined</p>
			</v-col>
		</v-row>

		<v-row no-gutters>
			<v-col align="center" justify="center" class="pb-3">
				<v-btn align="center" class="subtitle primary--text font-weight-bold" justify="center" @click="locumGotoSetAvailability()"
					>Find Offers <v-icon right>mdi-arrow-right</v-icon></v-btn
				>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import { bus } from '@/main';
export default {
	name: 'LocumBookingRejected',
	components: {},
	data: () => ({}),
	methods: {
		created() {
			//check if authenticated ?
		},

		locumGotoSetAvailability() {
			this.$emit('dismiss', this);
			window.scrollTo(0, 0);
			bus.$emit('change-context', 'locum-set-availability');
		},

		closeBookingConfirmed() {
			this.$emit('dismiss', this);
		},
	},
};
</script>
